import { LogicalExpressionParser } from "../../../../logic/LogicalExpressionParser";
import { Dialog } from "../../engine/model/Dialog";
import DefaultDialogPlayerCommand from "../player/DefaultDialogPlayerCommand";

export default class DefaultDialogParser {
        constructor(languagePack) {
            this.languagePack = languagePack;
            this.logicalExpressionParser = new LogicalExpressionParser();
        }

        destroy() {
            this.logicalExpressionParser = null;
        }

        parse(data) {
            const object = JSON.parse(data);
            return this.parseFromObject(object);
        }

        parseFromObject(object) {
            const states = object.states;
            const transitions = object.transitions;
            const dialog = new Dialog();
            const commandSequenceRegistry = {};

            let state;
            for (var i = 0; i < states.length; i++) {
                var stateObject = states[i];
                state = dialog.addState();
                state.id = stateObject.id;
                commandSequenceRegistry[stateObject.id] = state;
            }

            var transition;
            for (var j = 0; j < transitions.length; j++) {
                var transitionObject = transitions[j];
                transition = dialog.addTransition(commandSequenceRegistry[transitionObject.stateID]);
                transition.id = transitionObject.id;
                commandSequenceRegistry[transitionObject.id] = transition;
            }

            dialog.setStartState(commandSequenceRegistry[object.startStateID]);
            dialog.setMaxTime(object.maxTime);
            dialog.setTimeOutState(commandSequenceRegistry[object.timeOutStateID]);
            dialog.setData(object.data);

            for (var i = 0; i < states.length; i++) {
                var stateObject = states[i];
                this.configureCommandSequence(stateObject, commandSequenceRegistry);
            }

            var transition;
            for (var j = 0; j < transitions.length; j++) {
                var transitionObject = transitions[j];
                this.configureCommandSequence(transitionObject, commandSequenceRegistry);
            }
            return dialog;
        }

        configureCommandSequence(object, commandSequenceRegistry) {
            const commandSequence = commandSequenceRegistry[object.id];
            commandSequence.metaData = object.metaData;
            const commands = object.commands;
            const length = commands.length;
            let data;
            let commandObject;

            for (let i = 0; i < length; i++) {
                commandObject = commands[i];
                if (commandObject.data != null) {
                    data = new DefaultDialogPlayerCommand(this.languagePack);
                    data.setPropertiesFromObject(commandObject.data);
                } else {
                    data = null;
                }

                const condition = commandObject.condition == null ? null : this.logicalExpressionParser.parseLogicalExpression(commandObject.condition);
                //TODO: use the var below!
                const executeOnce = (commandObject.executeOnce == null) ? false : commandObject.executeOnce;
                let command;
                if (commandObject.type == "DialogOption") {
                    command = commandSequence.addOption(commandSequenceRegistry[commandObject.commandSequenceID], data, condition, commandObject.autoTake, commandObject.executeOnce);
                } else {
                    command = commandSequence.addCommand(data, condition, commandObject.executeOnce);
                }
                command.setMetaData(commandObject.metaData);
                data = null;
            }
        }
    }